import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductsColection } from '../products-colection/products-colection';
import { MatIcon } from '@angular/material/icon';
import { CdkAutofill } from '@angular/cdk/text-field';
import { NgClass } from '@angular/common';
import { Product } from '../../models/products-model/products.model';
import { MatButtonModule } from '@angular/material/button';
import { TicketSupply } from '../../models/ticket-model/tiket.model';
@Component({
  selector: 'app-expancion-card',
  imports: [ProductsColection, MatIcon, CdkAutofill, NgClass],
  templateUrl: './expancion-card.html',
  styleUrl: './expancion-card.css',
})
export class ExpancionCard {
  @Input() mobile: boolean = false;
  public isExpanded = false;
  @Input() viewMap = false;
  @Input() ticketPendingSupply: TicketSupply[] = [];
  @Input() folio = '';
  @Input() date = '';

  @Output() openMapEvent = new EventEmitter<void>();

  get totalAmount(): number {
    return this.ticketPendingSupply.reduce(
      (sum, product) => sum + (product?.Quantity ?? 0) * (product?.Supply?.Cost ?? 0),
      0,
    );
  }

  openMap() {
    this.openMapEvent.emit();
  }
}
